import './utilities/persian';
import './utilities/formula';
import './utilities/file';
import Jalali from 'jalali-date'; 
import Moment from 'moment';
import moment from 'moment-jalaali'; 
import MomentJalali from 'moment-jalali';

import data from './dictionary.json';

//  Debug line
window.gettext = function (text) {
    if(data[text]!==undefined)
    {
        return data[text];
    }
    return text;
};
window.pgettext = function (context, msgid) {
    var value = window.gettext(context + '\x04' + msgid);
    if (value.indexOf('\x04') != -1) {
      value = msgid;
    }
    return window.gettext(value);
}
window.interpolate = function(fmt, obj, named) {
    // debugger
    if (named) {
        return fmt.replace(/%\(\w+\)s/g, function(match) {
            return String(obj[match.slice(2, -2)])
        });
    } else {
        return fmt.replace(/%s/g, function(match) {
            return String(obj.shift())
        });
    }
}
window.images = {
    "post": "64fb3fcfb9d947c094304ae5eb7ec6da",
    "book_image_placeholder": "2b343b46f12f48c3957f90e976ede795",
    "navigation-buttons": "330a7af8419e46baa19d2f64ca2a5e50",
    "mellat": "2d43532d0519435b9e07f455c7fe9fbf",
    "logo": "a639ebb81a114b8ea03901ffbeccf9d5",
    "fav-icon": "748d0232c9e942e182ac84ae62745209"
}

window.hashed_paths = {

    'tinymce_formula.html': 'static/tinymce/tinymce_formula.html',

    'tinymce_guide.html': 'static/tinymce/tinymce_guide.html',

    'tinymce_effects.html': 'static/tinymce/tinymce_effects.html',

    'tinymce_upload_image.html': 'static/tinymce/tinymce_upload_image.html',

    'css/tinymce.css': window.location.origin+'/css/tinymce.css',

    'css/mathjax.css': window.location.origin+'/css/mathjax.css',

    'css/question.css': window.location.origin+'/css/question.css',

    'js/tinymce.min.js': window.location.origin+'/static/tinymce/tinymce.js',
}


function closeMenu(event) {
    if (!event.altKey || !event.ctrlKey || event.button !== 2)
        return;
    event.preventDefault();
    event.stopPropagation();
    const element = document.querySelectorAll('[style*="position: fixed"][style*="z-index: 10;"]')[0];
    if (element.style.display === 'none')
        element.style.display = '';
    else
        element.style.display = 'none';
}
function init() {
    document.addEventListener('mousedown', closeMenu);
    document.addEventListener('contextmenu', event => {
        if (event.altKey && event.ctrlKey && event.button === 2)
            event.preventDefault()
    }
        , true);
    window.handsontable_stylesheet = `<link href="/static/handsontable.css" rel="stylesheet" type="text/css" />`;
    // MathJax.Hub.Config({
    //     config: ['MMLorHTML.js'],
    //     jax: ['input/TeX', 'input/MathML', 'input/AsciiMath', 'output/HTML-CSS', 'output/NativeMML', 'output/PreviewHTML'],
    //     extensions: ['tex2jax.js', 'mml2jax.js', 'asciimath2jax.js', 'fast-preview.js', 'AssistiveMML.js'],
    //     TeX: {
    //         extensions: ['AMSmath.js', 'AMSsymbols.js', 'AMScd.js', 'noErrors.js', 'noUndefined.js', 'cancel.js', 'mhchem.js', 'autobold.js', ],
    //     },
    //     'HTML-CSS': {
    //         mtextFontInherit: true,
    //     },
    //     messageStyle: 'none',
    //     menuSettings: {
    //         inTabOrder: false,
    //         context: 'Browser',
    //     },
    //     processSectionDelay: 0,
    //     skipStartupTypeset: true,
    // });
    // MathJax.Hub.Configured();
}

// init();

// End of Debug line

window.mobile = /Mobi/i.test(navigator.userAgent);

window.MomentJalali = MomentJalali;

window.uuidv4 = function () {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
};

// console.log("gettext: "+gettext)

window.wait = async (ms = 0) => {
    return new Promise(resolve => {
        setTimeout(resolve, ms);
    });
};

window.renderStoreItemHelper = uuid => {
    const render = () => {
        if (window.renderStoreItem)
            window.renderStoreItem(uuid);
        else
            window.setTimeout(render, 1000);
    };
    render();
};

String.prototype.format = function () {
    var e = this.toString();
    if (!arguments.length)
        return e;
    var t = typeof arguments[0];
    var n = 'string' == t || 'number' == t
        ? Array.prototype.slice.call(arguments)
        : arguments[0];
    for (var i in n)
        e = e.replace(new RegExp('\\{' + i + '\\}', 'gi'), n[i]);
    return e;
};

Date.prototype.toJalali = function () {
    return moment(this);
}

Jalali.prototype.persian = function (format) {
    const jalaliDate = moment(this._dd);
    if (format) {
        format = format.replace(/m/g, '\x10');
    }
    const formattedDate = jalaliDate.format(format || 'jdddd - jYYYY/jMM/jDD');
    return formattedDate.replace(new RegExp('\x10', 'g'), 'm');
};

String.prototype.toJalali = function () {
    if (!this)
        return '-';
    return Number(this).toJalali();
};

Number.prototype.toJalali = function () {
    if (this === 0)
        return '-';
    const timestamp = this < 10000000000 ? this * 1000 : this;
    return new Date(timestamp).toJalali();
};

Number.prototype.pad = function (size) {
    var string = String(this);
    while (string.length < (size || 2)) { string = '0' + string; }
    return string;
};
moment.fn.persian = function (format = 'jYYYY/jMM/jDD') {
    if(format && !format.includes("j")){
        format = format.replace("YYYY","jYYYY")
        format = format.replace("MM","jMM")
        format = format.replace("DD","jDD")
    }
    return this.format(format).persian();
};
Number.prototype.timerFormat = function () {
    const seconds = Math.floor(this % 60);
    const minutes = Math.floor(this / 60) % 60;
    const hours = Math.floor(this / 3600) % 24;
    const days = Math.floor(this / 3600 / 24);
    return (
        (days ? days + ' ' + window.gettext('Days') + ' ' : '') +
        (hours ? `${hours.pad()}:` : '') +
        `${minutes.pad()}:${seconds.pad()}`
    ).persian();
};

RegExp.prototype.toPartialMatchRegex = function () {
    const source = this.source;
    let counter = 0;

    const process = () => {
        let result = '', tmp;

        function appendRaw(nbChars) {
            result += source.substr(counter, nbChars);
            counter += nbChars;
        };

        function appendOptional(nbChars) {
            result += '(?:' + source.substr(counter, nbChars) + '|$)';
            counter += nbChars;
        };

        while (counter < source.length) {
            switch (source[counter]) {
                case '\\':
                    switch (source[counter + 1]) {
                        case 'c':
                            appendOptional(3);
                            break;

                        case 'x':
                            appendOptional(4);
                            break;

                        case 'u':
                            if (this.unicode) {
                                if (source[counter + 2] === '{') {
                                    appendOptional(source.indexOf('}', counter) - counter + 1);
                                } else {
                                    appendOptional(6);
                                }
                            } else {
                                appendOptional(2);
                            }
                            break;

                        default:
                            appendOptional(2);
                            break;
                    }
                    break;

                case '[':
                    tmp = /\[(?:\\.|.)*?\]/g;
                    tmp.lastIndex = counter;
                    tmp = tmp.exec(source);
                    appendOptional(tmp[0].length);
                    break;

                case '|':
                case '^':
                case '$':
                case '*':
                case '+':
                case '?':
                    appendRaw(1);
                    break;

                case '{':
                    tmp = /\{\d+,?\d*\}/g;
                    tmp.lastIndex = counter;
                    tmp = tmp.exec(source);
                    if (tmp) {
                        appendRaw(tmp[0].length);
                    } else {
                        appendOptional(1);
                    }
                    break;

                case '(':
                    if (source[counter + 1] == '?') {
                        switch (source[counter + 2]) {
                            case ':':
                                result += '(?:';
                                counter += 3;
                                result += process() + '|$)';
                                break;

                            case '=':
                                result += '(?=';
                                counter += 3;
                                result += process() + ')';
                                break;

                            case '!':
                                tmp = counter;
                                counter += 3;
                                process();
                                result += source.substr(tmp, counter - tmp);
                                break;
                        }
                    } else {
                        appendRaw(1);
                        result += process() + '|$)';
                    }
                    break;

                case ')':
                    ++counter;
                    return result;

                default:
                    appendOptional(1);
                    break;
            }
        }

        return result;
    };

    return new RegExp(process(), this.flags);
};

window.toFormData = function (object, formdata = new FormData(), pre) {
    if (Array.isArray(object)) {
        object.forEach((value, index) => {
            const key = (pre || '_') + '-' + index;
            if (value === undefined) { }
            else if (Object(value) === value && !(value instanceof File)) {
                window.toFormData(value, formdata, key);
            }
            else {
                formdata.append(key, value);
            }
        });
    }
    else {
        Object.keys(object).forEach(prop => {
            const key = pre ? pre + '.' + prop : prop;
            const value = object[prop];
            let type = '';
            try {
                type = value.constructor.name;
            }
            catch (exception) { }
            if (value === undefined) { }
            else if (Object(value) === value && type !== 'File') {
                window.toFormData(value, formdata, key);
            }
            else {
                formdata.append(key, value);
            }
        });
    }
    return formdata;
};

document.addEventListener('keydown', async event => {
    const element = event.target;
    if (!(element instanceof HTMLInputElement) && !(element instanceof HTMLTextAreaElement))
        return;

    const beginning = element.selectionStart;
    const end = element.selectionEnd;
    let value = element.value;

    const numbar = element.dataset.english ? 1 : (() => {
        // if (/_mhelli_tinymce_numbar=1/.test(top.document.cookie))
        //     return 1;
        // else if (/_mhelli_tinymce_numbar=2/.test(top.document.cookie))
        //     return 2;
        // else
        return 2;
    })();
    const numpad = element.dataset.english ? 1 : (() => {
        // if (/_mhelli_tinymce_numpad=1/.test(top.document.cookie))
        //     return 1;
        // else if (/_mhelli_tinymce_numpad=2/.test(top.document.cookie))
        //     return 2;
        // else
        return 1;
    })();

    const keyCode = (event.keyCode || event.charCode);
    let content = '';
    if (keyCode >= 48 && keyCode <= 57 && !event.shiftKey && !event.altKey) {
        if (event.ctrlKey ^ (numbar === 1))
            content = (keyCode - 48).persian();
        else
            content = String(keyCode - 48);
    }
    if (keyCode === 190 && !event.shiftKey && !event.altKey) {
        if (event.ctrlKey ^ (numbar === 1))
            content = '٫';
        else
            content = '.';
    }

    if (keyCode >= 96 && keyCode <= 105 && !event.shiftKey && !event.altKey) {
        if (event.ctrlKey ^ (numpad === 1))
            content = (keyCode - 96).persian();
        else
            content = String(keyCode - 96);
    }
    if (keyCode === 110 && !event.shiftKey && !event.altKey) {
        if (event.ctrlKey ^ (numpad === 1))
            content = '٫';
        else
            content = '.';
    }
    if (keyCode === 71 && event.altKey)
        content = 'ٔ';

    if (event.key === 'ي') {
        if (!event.shiftKey)
            content = 'ی';
    }
    if (event.key === 'ك') {
        if (!event.shiftKey)
            content = 'ک';
    }

    if (content) {
        event.preventDefault();

        value = value.substring(0, beginning) + content + value.substr(end);
        element.value = value;

        function deletePropertySafe(elem, prop) {
            var desc = Object.getOwnPropertyDescriptor(elem, prop);
            if (desc && desc.configurable) {
                delete elem[prop];
            }
        }

        const descriptor = Object.getOwnPropertyDescriptor(element, 'value');

        // React 0.14: IE9
        // React 15: IE9-IE11
        // React 16
        // In IE9-10 imperative change of node value triggers propertychange event.
        // Update inputValueTracking cached value.
        // Remove artificial value property.
        // Restore initial value to trigger event with it.
        const initialValue = element.value;
        element.value = initialValue + '#';
        deletePropertySafe(element, 'value');
        element.value = initialValue;

        // React 15: IE11
        // For unknown reason React 15 added listener for propertychange with addEventListener.
        // This doesn't work, propertychange events are deprecated in IE11,
        // but allows us to dispatch fake propertychange which is handled by IE11.
        event = document.createEvent('HTMLEvents');
        event.initEvent('propertychange', false, false);
        event.propertyName = 'value';
        element.dispatchEvent(event);

        // React 0.14: IE10-IE11, non-IE
        // React 15: non-IE
        // React 16: IE10-IE11, non-IE
        event = document.createEvent('HTMLEvents');
        event.initEvent('input', true, false);
        element.dispatchEvent(event);

        // React 16
        // Restore artificial value property descriptor.
        if (descriptor) {
            Object.defineProperty(element, 'value', descriptor);
        }

        await window.wait();
        element.setSelectionRange(beginning + content.length, beginning + content.length);
    }
});

window.gettext('Request is missing username parameter.');
window.gettext('Request is missing password parameter.');
